var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmoduleCoupon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12172",
    "data-name": "Group 12172",
    transform: "translate(-3507 5518)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2889",
    "data-name": "Rectangle 2889",
    width: 35,
    height: 35,
    rx: 3,
    transform: "translate(3507 -5518)",
    fill: "#ff8d28"
  }), /*#__PURE__*/React.createElement("g", {
    id: "module",
    transform: "translate(3515 -5551.443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12047",
    "data-name": "Group 12047",
    transform: "translate(0 42.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49591",
    "data-name": "Path 49591",
    d: "M301.051,168.191l-9.406,3.527v2.055l9.406-3.527Z",
    transform: "translate(-281.064 -163.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49592",
    "data-name": "Path 49592",
    d: "M9.406,262.973,0,259.446v2.049l9.406,3.527Z",
    transform: "translate(0 -250.951)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49593",
    "data-name": "Path 49593",
    d: "M291.646,265.021l9.406-3.527v-2.049l-9.406,3.527Z",
    transform: "translate(-281.064 -250.951)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49594",
    "data-name": "Path 49594",
    d: "M9.406,173.773v-2.055L0,168.191v2.055Z",
    transform: "translate(0 -163.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49595",
    "data-name": "Path 49595",
    d: "M291.646,354.045v2.2l9.406-3.527v-2.2Z",
    transform: "translate(-281.064 -338.445)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49596",
    "data-name": "Path 49596",
    d: "M9.406,354.045,0,350.518v2.2l9.406,3.527Z",
    transform: "translate(0 -338.445)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49597",
    "data-name": "Path 49597",
    d: "M25.608,49.5l9.406-3.527-9.406-3.527L16.2,45.97Z",
    transform: "translate(-15.615 -42.443)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoduleCoupon);
export default __webpack_public_path__ + "static/media/EmoduleCoupon.77f7c4d449fe016139cf1bd2a95a1b16.svg";
export { ForwardRef as ReactComponent };